module.exports = __webpack_public_path__ + "img/Menu-08.6a36fb1f.png";